import { useState } from "react";

import { makePostApiCall, makePutApiCall } from "../../../shared/makeApiCall";
import CarrierDetailsForm from "../../../components/forms/setup/carriers/CarrierDetailsForm";
import { createSnackbarHelpers } from "../../../shared/snackbar";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import { updateObjectInArray } from "../../../shared/utility";

export function CarriersViewModel(logout, addSnackbar) {
  const [loading, setLoading] = useState(false);
  const [carriers, setCarriers] = useState({
    data: [],
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const { showSuccess } = createSnackbarHelpers(addSnackbar);

  const getCarriers = async function (search, page) {
    setLoading(true);

    let callResult = await makePostApiCall(
      `carriers?page=${page}&search=${search}`
    );
    setLoading(false);
    if (callResult.success) {
      setCarriers(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createCarrier = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall("carriers/create", payload);

    if (callResult.success) {
      showSuccess("Carrier added");
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getCarriers("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateCarrier = async function (values, index) {
    let callResult = await makePutApiCall(`carriers/${values.id}`, values);

    if (callResult.success) {
      showSuccess("Carrier updated");
      setSlideOver({
        childComponent: null,
        open: false,
      });

      const currentItems = [...carriers.data];
      var payload = {
        index: index,
        item: callResult.data.item,
      };
      const newItems = updateObjectInArray(currentItems, payload);
      setCarriers({ ...carriers, data: newItems });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddCarrierSlideOver = (isEdit, carrier, index) => {
    setSlideOver({
      childComponent: (
        <CarrierDetailsForm
          carrier={carrier}
          isEdit={isEdit}
          setOpen={setSlideOver}
          actionCall={(payload) =>
            isEdit ? updateCarrier(payload, index) : createCarrier(payload)
          }
          title={isEdit ? `Update ${carrier.name}` : "Add new carrier"}
        />
      ),
      open: true,
    });
  };

  const deleteCarrier = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteCarrier/${id}`);
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const newItems = carriers.data.filter((item) => item.id !== id);
      setCarriers({ ...carriers, data: newItems });

      showSuccess(callResult.data.message);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteCarrier = function (carrier, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteCarrier(carrier.id, index)}
          message={`Are you sure you want to delete  ${carrier.name}?`}
          setOpen={setEmptyModelOpen}
          hideReason={true}
        />
      ),
      open: true,
    });
  };

  return {
    openAddCarrierSlideOver,
    getCarriers,
    loading,
    carriers,
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    emptyModal,
    askDeleteCarrier,
  };
}
